/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ChevronDownLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="chevron-down-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M210.0633333333333 946.73L680 476.7933333333334L1149.9366666666665 946.73L1230.0633333333333 866.6033333333332L680 316.54L129.9366666666667 866.6033333333332L210.0633333333333 946.73z" : "M168.0506666666667 757.384L544 381.4346666666667L919.9493333333334 757.384L984.0506666666668 693.2826666666666L544 253.2319999999999L103.9493333333333 693.2826666666666L168.0506666666667 757.384z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ChevronDownLg.displayName = `Blueprint5.Icon.ChevronDownLg`;
export default ChevronDownLg;
